const Footer = (props) => {
  return (
    <footer

      className="container-fluid text-center p-4  text-white mt-auto  "
      // className="container-fluid text-center p-4  text-white  "
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.20)",
        // position: "relative",
        // bottom: "0",
      }}

    >
      <h6>Lot Ninja - 2023</h6>
    </footer>
    
  );
};
export default Footer;

// import React from 'react';
// import {  } from 'react-bootstrap';


// function Footer(props){
//   return (
//     <footer bgColor='light' className='text-center text-lg-start text-muted'>
//     <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
//         © 2021 Copyright:
//         <a className='text-reset fw-bold' href='https://mdbootstrap.com/'>
//           MDBootstrap.com
//         </a>
//       </div>
//     </footer>
//   )
// }

// export default Footer;


// const Footer = () => {
//   return <footer>
//     <Container>
//       <Row>
//         <Col className='text-center py-3 container-fluid '>
//           Copyright &copy; Ninja Lot Map
//         </Col>
//       </Row>
//     </Container>
//   </footer>
// }

// export default Footer;

// import React from 'react';

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-6">
//             <h5>About Us</h5>
//             <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce maximus metus vel urna blandit, eu ultrices ligula vestibulum.</p>
//           </div>
//           <div className="col-md-3">
//             <h5>Links</h5>
//             <ul className="list-unstyled">
//               <li><a href="/">Home</a></li>
//               <li><a href="/about">About</a></li>
//               <li><a href="/services">Services</a></li>
//               <li><a href="/contact">Contact</a></li>
//             </ul>
//           </div>
//           <div className="col-md-3">
//             <h5>Contact Us</h5>
//             <ul className="list-unstyled">
//               <li><i className="fa fa-phone"></i> +1 123 456 7890</li>
//               <li><i className="fa fa-envelope"></i> info@example.com</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
